import React, { useCallback, useEffect, useState } from "react";
import img1 from "../../assets/img/37.png";
import img2 from "../../assets/img/38.png";
import logo1 from "../../assets/img/logoPro.png";
import authDark from "../../assets/img/auth-dark.png";
import { Link, useNavigate } from "react-router-dom";
import useApiRequest from "../../Hooks/apiReq";
import { validateLoginForm } from "../../Validation/LoginVal";
import { toast } from "react-toastify";
import { APP_VERSION } from "../../Utils/AppVersion";
import Loader from "../Loader";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import { FaKey, FaUser } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { uiAction } from "../../Redux/Slices/uiSlice";
const Login = () => {
  const [lastClicked, setLastClicked] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loginData, setLoginData] = useState({
    LoginId: "",
    Password: "",
  });
  const { error, loading, recallRequest, response, sendApiRequest, status } =
    useApiRequest();
  const handleLogin = async () => {
    // api call restriction
    const now = new Date().getTime();
    if (now - lastClicked < 3000) {
      return;
    }
    setLastClicked(now);
    // validation and api call
    if (validateLoginForm(loginData)) {
      sendApiRequest(
        "POST",
        "/Auth/associate-login",
        {
          ...loginData,
          AppVersion: APP_VERSION,
          DeviceType: "Web",
        },
        {
          onSuccess: (res) => {
            sessionStorage.setItem("loggedInUser", res.token);
            sessionStorage.setItem("loggedInTime", new Date().toISOString());
            // sessionStorage.setItem("AppType", "Business");
            dispatch(uiAction.updateAppType("Business"));
            toast.success(res.message);
            // navigate("/switcher", { replace: true });
            navigate("/dashboard", { replace: true });
          },
        },
      );
    }
  };
  const handleChange = useCallback((e) => {
    const { id, value } = e.target;
    setLoginData((pre) => ({ ...pre, [id]: value }));
  }, []);
  const [bool, setbool] = useState(false);
  const handlebool = () => {
    setbool(!bool);
  };
  const handlekeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <main className="main" id="top">
      <div className="container-fluid bg-body-tertiary dark__bg-gray-1200 ">
        <div
          className="bg-holder bg-auth-card-overlay bgColor"
          style={{ backgroundImage: `url(${img1})` }}
        ></div>

        <div className="row flex-center position-relative min-vh-100 g-0 py-5">
          <div className="col-11 col-sm-10 col-xl-8  align-items-center d-flex d-md-block justify-content-center ">
            <div className="card border border-translucent auth-card">
              <div className="card-body pe-md-0">
                <div className="row align-items-center gx-0 gy-7">
                  <div className="col-auto bg-body-highlight dark__bg-gray-1100 rounded-3 position-relative overflow-hidden auth-title-box">
                    <div
                      className="bg-holder"
                      style={{ backgroundImage: `url(${img2})` }}
                    ></div>

                    <div className="position-relative px-4 px-lg-7 pt-7 pb-7 pb-sm-5 text-center text-md-start pb-lg-7 pb-md-7">
                      <h3 className="mb-3 text-body-emphasis fs-7">
                        RAV Property Login
                      </h3>
                      <p className="text-body-tertiary">
                        Every great deal begins with a single login. Let's build
                        something amazing!
                      </p>
                      <ul className="list-unstyled mb-0 w-max-content w-md-auto">
                        <li className="d-flex align-items-center">
                          <span className="uil uil-check-circle text-success me-2"></span>
                          <span className="text-body-tertiary fw-semibold">
                            RAV Property
                          </span>
                        </li>
                        <li className="d-flex align-items-center">
                          <span className="uil uil-check-circle text-success me-2"></span>
                          <span className="text-body-tertiary fw-semibold">
                            RAV Organics
                          </span>
                        </li>
                      </ul>
                    </div>

                    <div className="position-relative z-n1 mb-6 d-none d-md-block text-center mt-md-15">
                      <img
                        className="auth-title-box-img d-dark-none"
                        src={authDark}
                        alt=""
                      />
                      <img
                        className="auth-title-box-img d-light-none"
                        src={authDark}
                        alt="authpic"
                      />
                    </div>
                  </div>

                  <div className="col mx-auto">
                    <div className="auth-form-box">
                      <div className="text-center mb-7">
                        <a className="d-flex flex-center text-decoration-none mb-2">
                          <div className="d-flex flex-center text-decoration-none mb-4">
                            <img src={logo1} alt="phoenix" width="158" />
                          </div>
                        </a>
                        <h3 className="mb-3 text-body-emphasis fs-7 textColor">
                          Your gateway to seamless property booking starts here!
                        </h3>
                        {/* <p className="text-body-tertiary">
                          Access the RAV Channel Partner Panel.
                        </p> */}
                      </div>
                      {/* <div className="position-relative">
                        <hr className="bg-body-secondary mt-5 mb-4" />
                        <div className="divider-content-center bg-body-emphasis">
                          or use Login Id
                        </div>
                      </div> */}
                      <div className="mb-3 text-start">
                        {/* <label className="form-label" htmlFor="LoginId">
                          Login Id
                        </label>
                        <div className="form-icon-container">
                          <input
                            className="form-control form-icon-input"
                            id="LoginId"
                            type="text"
                            placeholder="Login Id"
                            value={loginData?.LoginId}
                            onChange={handleChange}
                          />

                        </div> */}

                        <div className="mb-3 text-start">
                          <label className="form-label" htmlFor="LoginId">
                            Your ID
                          </label>
                          <div class="form-icon-container">
                            <input
                              onChange={handleChange}
                              autoComplete="off"
                              onKeyDown={handlekeyPress}
                              className="form-control form-icon-input "
                              value={loginData?.LoginId}
                              id="LoginId"
                              type="text"
                              placeholder="Enter your registered ID to access your world"
                            />
                            <span className="  text-body fs-9 form-icon">
                              <FaUser className="mb-3" />
                            </span>
                          </div>
                        </div>
                        <div class="mb-3 text-start">
                          <label class="form-label" htmlFor="Password">
                            Password
                          </label>
                          <div
                            class="form-icon-container"
                            data-password="data-password"
                          >
                            <input
                              value={loginData?.Password}
                              onChange={handleChange}
                              onKeyDown={handlekeyPress}
                              autoComplete="off"
                              class="form-control form-icon-input pe-6"
                              id="Password"
                              type={bool ? "text" : "password"}
                              placeholder="Password"
                              data-password-input="data-password-input"
                            />
                            <span class="text-body fs-9 form-icon">
                              <FaKey className="mb-3" />
                            </span>
                            <div class="icon-eye">
                              {!bool ? (
                                <span>
                                  <IoEyeOffOutline
                                    onClick={handlebool}
                                    color="black"
                                    size={20}
                                  />
                                </span>
                              ) : (
                                <span>
                                  {" "}
                                  <IoEyeOutline
                                    onClick={handlebool}
                                    color="black"
                                    size={20}
                                  />
                                </span>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* <div className="col-12 mb-3">
                          <InputBox
                            id="LoginId"
                            value={loginData?.LoginId}
                            onChange={handleChange}
                            type="text"
                            placeholder="Login Id"
                            label="Login Id"
                            required={true}
                          />
                        </div> */}
                        {/* <span className="fas fa-user text-body fs-9 form-icon"></span> */}
                      </div>

                      {/*
                      <div className="mb-3 text-start">

                        <div className="col-12 mb-3">
                          <InputBox
                            id="Password"
                            value={loginData?.Password}
                            onChange={handleChange}
                            type="password"
                            placeholder="Password"
                            label="Password"
                            required={true}
                            onkeydown={handlekeyPress}
                          />
                        </div>
                      </div> */}

                      <div className="row flex-between-center mb-7">
                        <div className="col-auto">
                          <div className="form-check mb-0">
                            <input
                              className="form-check-input"
                              id="basic-checkbox"
                              type="checkbox"
                              defaultChecked
                            />
                            <label
                              className="form-check-label mb-0"
                              htmlFor="basic-checkbox"
                            >
                              Remember me
                            </label>
                          </div>
                        </div>
                        <div className="col-auto">
                          <Link
                            className="fs-9 fw-semibold"
                            to="/forget-password"
                          >
                            Forgot Password?
                          </Link>
                        </div>
                      </div>

                      <button
                        onClick={handleLogin}
                        className="btn btn-primary w-100 mb-3"
                      >
                        Sign In
                      </button>

                      {/* <div className="text-center">
                        <a
                          className="fs-9 fw-bold"
                          href="authentication/card/sign-up.html"
                        >
                          Create an account
                        </a>
                      </div> */}
                    </div>
                  </div>
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
      {loading && <Loader />}
    </main>
  );
};

export default Login;
